/**
 * Τρόποι πληρωμής του Take Away και τι στέλνει ο καθένας στον server.
 *
 * «Επί πιστώσει» (κωδ. ΑΑΔΕ 5) — απόφαση ιδιοκτήτη 6/10/2026: κανονικός τρόπος πληρωμής, χωρίς
 * διακόπτη, με απόδειξη (11.1/11.2) ή τιμολόγιο (1.1/2.1), μόνο από το ταμείο. Ακολουθεί τη ροή
 * των μετρητών (χωρίς τερματικό), αλλά δηλώνεται ΡΗΤΑ: ποτέ σιωπηλά ως μετρητά (κωδ. 3, συρτάρι).
 */
export type TakeawayPaymentMethod = 'cash' | 'card' | 'iris' | 'credit';

/** Μετρητά και «Επί πιστώσει»: χωρίς τερματικό POS (παραγγελία → παραστατικό). */
export const isNoTerminalMethod = (m: TakeawayPaymentMethod | null): m is 'cash' | 'credit' =>
  m === 'cash' || m === 'credit';

/** IRIS και «Επί πιστώσει» ζουν κάτω από «Περισσότερα» (γρήγορα κουμπιά: Μετρητά, Κάρτα). */
export const isExtraMethod = (m: TakeawayPaymentMethod | null): boolean =>
  m === 'iris' || m === 'credit';

/**
 * Το πεδίο τρόπου πληρωμής στο σώμα του POST /fiscal/receipt/cash.
 * Μετρητά: κανένα πεδίο — το σώμα μένει ίδιο με πριν. «Επί πιστώσει»: ο server δηλώνει κωδ. 5,
 * τυπώνει «ΕΠΙ ΠΙΣΤΩΣΗ» και δεν ανοίγει συρτάρι.
 * 'deposit' (14/10/2026): η προκαταβολή πελάτη καλύπτει ΟΛΟ το ποσό — ο server βγάζει τους τρόπους από την
 * προκαταβολή, χωρίς συρτάρι (409 deposit_partial αν μένει υπόλοιπο).
 */
export function cashReceiptPaymentField(method: 'cash' | 'credit' | 'deposit'): { paymentMethod?: 'credit' | 'deposit' } {
  if (method === 'credit') return { paymentMethod: 'credit' };
  if (method === 'deposit') return { paymentMethod: 'deposit' };
  return {};
}

/**
 * paymentMethodId του τιμολογίου χωρίς τερματικό: 3 μετρητά, 5 «Επί πιστώσει».
 * Οτιδήποτε άλλο κρατά το 7 (κάρτα), όπως πριν.
 */
export function invoicePaymentMethodId(method: TakeawayPaymentMethod | null): 3 | 5 | 7 {
  if (method === 'cash') return 3;
  if (method === 'credit') return 5;
  return 7;
}
